export const formatNumber = (num) => {
  if (typeof num === "number") {
    // Round the number to two decimal places
    num = Math.round(num * 100) / 100;

    // Convert the number to a string
    const numStr = num.toString();

    // Split the number string into integer and decimal parts
    const [integerPart, decimalPart] = numStr.split(".");

    // Add commas to the integer part
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // If there's a decimal part, format it and return the complete string
    if (decimalPart !== undefined) {
      return `${formattedInteger}.${decimalPart.padEnd(2, "0")}`;
    }

    // Otherwise, just return the formatted integer part
    return formattedInteger;
  }
  return num;
};

export const formatDate = (date, isForQuery = false) => {
  if (!(date instanceof Date)) return String(date);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = String(date.getFullYear());
  const hh = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  if (isForQuery) return `${yyyy}-${month}-${dd}T${hh}:${minute}:${ss}`;
  return `${month}/${dd}/${yyyy} ${hh}:${minute}:${ss}`;
};

export const getRealPhoneNumber = (phoneNumberString) => {
  return ("" + phoneNumberString).replace(/\D/g, "");
};

export const formatPhoneNumber = (phoneNumberString) => {
  // Remove non-numeric characters
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  // Check if the number is a valid US phone number
  const match = cleaned.match(/^.?.?.?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return null; // Return null if the number is not valid
};

export const formatPhoneNumberWithoutPrefix = (phoneNumberString) => {
  // Remove non-numeric characters
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");

  // Define match patterns for various phone number formats
  const formats = [
    { pattern: /^(\d{3})(\d{3})(\d{4})/, format: "($1) $2-$3" }, // (XXX) XXX-XXXX
    { pattern: /^(\d{3})(\d{3})(\d{1,4})/, format: "($1) $2-$3" }, // (XXX) XXX-XXX or (XXX) XXX-X
    { pattern: /^(\d{3})(\d{1,3})/, format: "($1) $2" }, // (XXX) XXX or (XXX) XX
    { pattern: /^(\d{1,3})/, format: "($1" }, // (XXX or (XX or (X
  ];

  // Iterate over formats and return the first match
  for (const { pattern, format } of formats) {
    const match = cleaned.match(pattern);
    if (match) {
      return format.replace(/\$(\d)/g, (_, idx) => match[idx]); // Replace placeholders with matched values
    }
  }

  return null; // Return null if the number is not valid
};


export const stringToColor = (str) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const stringToHSL = (str) => {
  // Calculate a hash based on the string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
      hash += str.charCodeAt(i);
  }
  
  // Derive hue from the hash, ensuring it wraps around 360
  const h = hash % 360;

  // Derive saturation and lightness
  const s = (hash % 100);   // Random saturation from 0 to 100%
  const l = 50;              // Set lightness to 50% for vibrant colors

  // Return the HSL color string
  return `hsl(${h}, ${s}%, ${l}%)`;
}

export const commaStyle = (price) => {
  let tmp = '';
  let value = Number(price);
  let counter = 10;
  if (value < 1000) return value;
  while (value && counter) {
    counter--;
    let ext = value % 1000;
    value = Math.floor(value / 1000);
    if (value >= 1) {
      tmp = String(ext).padStart(3, '0') + tmp;
      tmp = ',' + tmp;
    } else tmp = String(ext) + tmp;
  }
  return tmp;
};

export const slugify = (text) =>{
  // Convert to lowercase
  let slug = text.toLowerCase();

  // Remove accents (diacritics)
  slug = slug.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Replace non-alphanumeric characters with hyphens
  slug = slug.replace(/[^a-z0-9]+/g, "-");

  // Remove leading and trailing hyphens
  slug = slug.replace(/^-+|-+$/g, "");

  return slug;
}